import React from 'react';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import BenefitIcon from 'page_modules/compare/components/ProductAttributesTable/BenefitIcon';
import customStyles from 'page_modules/compare/__styles__/attributesTable.scss?modules';
import { getUpgradeEepForLink } from 'src/universal/utils/orchestraUtils';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';
import isProduction from 'src/universal/utils/isProduction';
import parseArrayToObject from 'src/universal/utils/parseArrayToObject';

export const getFormattedCtaLinks = ({ originalLinks, pageEep, pznOffer = {} }) => {
  const formattedLinks = (originalLinks || []).map(link => {
    const upgradeEep = getUpgradeEepForLink(link, pznOffer);
    const pznEep = pznOffer.eep;
    const eepToUse = upgradeEep || pznEep || pageEep;
    const { url } = link;
    const amexHost = isProduction()
      ? 'www.americanexpress.com'
      : 'qwww.americanexpress.com';
    const urlWithEep = replaceStringWithVars({
      varsObject: {
        amexHost: amexHost,
        eep: eepToUse
      },
      string: url
    });
    return {
      ...link,
      url: urlWithEep
    };
  });

  return parseArrayToObject(formattedLinks, 'key');
};

export const buildModalDataList = (cardList = [], pageEep = '') => {
  return (cardList || []).reduce((arrAcc, card) => {
    const srcObj = card ? card.interstitialToApp : null;
    if (srcObj) {
      const applyCta = srcObj.applyButton || srcObj.button;
      const srcUrl = applyCta.url || '';
      const applyButton = {
        ...applyCta,
        type: 'Primary',
        key: 'applyModalAccept',
        text: 'Continue',
        url: srcUrl.endsWith('=') ? `${srcUrl}${pageEep}` : srcUrl,
        dtm: {
          ...applyCta.dtmTag
        }
      };
      const cancelButton = {
        ...srcObj.cancelButton,
        type: 'Secondary',
        key: 'applyModalCancel',
        text: 'Cancel',
        dtm: {
          ...srcObj.cancelButton.dtmTag
        }
      };
      arrAcc.push({
        modalData: {
          ...srcObj,
          applyButton,
          cancelButton,
          button: undefined,
          cardHeadline: card.cardHeadline
        },
        cardName: card.shortName
      });
    }
    return arrAcc;
  }, []);
};

export const buildAttrCellDisplay = (matchedItem, attrName) => {
  /*
  matchedItem:
  if present, the target attribute is defined for the given card.
  if absent, then the target attribute is not defined for the given card.
  */
  let resultObj = {};
  if (matchedItem && typeof matchedItem.text === 'string') {
    resultObj = {
      ...matchedItem,
      Component: (
        <Sanitizer
          Component="div"
          className={customStyles.textVal}
          safelySetInnerHTML={matchedItem.text}
        />
      )
    };
  } else if (matchedItem) {
    resultObj = {
      ...matchedItem,
      Component: <BenefitIcon isDash={false} />
    };
  } else {
    resultObj = {
      key: attrName,
      Component: <BenefitIcon isDash={true} />
    };
  }

  return resultObj;
};
